import { siteApiSlice } from "../../app/siteApiSlice";

export interface StudentTeacherImpersonationResultModel {
	errorCreatingStudentAccount: boolean;
	errorImpersonatingStudent: boolean;
	errorLoggingIntoTeacherAccount: boolean;
}

// Mirrors Microsoft.AspNet.Identity.IdentityResult returned by AccountController.Impersonate.
export interface ImpersonateResultModel {
	succeeded: boolean;
	errors: string[];
}

export const impersonationApiSlice = siteApiSlice.injectEndpoints({
	endpoints: (build) => ({
		signInAsStudent: build.query<StudentTeacherImpersonationResultModel | void, void>({
			query: () => `/SignIn/SignInAsStudent`,
		}),
		signInAsTeacher: build.query<StudentTeacherImpersonationResultModel | void, void>({
			query: () => `/SignIn/SignInAsTeacher`,
		}),
		impersonateUser: build.mutation<ImpersonateResultModel, number>({
			query: (userId) => ({
				url: `/Account/Impersonate`,
				method: "POST",
				body: { userId },
			}),
		}),
		endImpersonation: build.mutation<ImpersonateResultModel, void>({
			query: () => ({
				url: `/Account/EndImpersonation`,
				method: "POST",
			}),
		}),
	}),
});

export const {
	useLazySignInAsStudentQuery,
	useLazySignInAsTeacherQuery,
	useImpersonateUserMutation,
	useEndImpersonationMutation,
} = impersonationApiSlice;
